<template>
    <v-container class="ma-0 pt-1 pb-0 px-0">
        <v-row no-gutters v-if="loading" class="pa-2 ma-0">
            <v-progress-circular
                    indeterminate
                    size="64"
                    width="7"
                    color="primary"
                    ></v-progress-circular>
        </v-row>
        <v-row v-else no-gutters class="flex-row" pa-0 ma-0 >
            <v-col cols="12" sm="12" md="3" class="d-flex align-start justify-end order-xs-1 order-sm-1 order-md-2 py-1">
                <slot name="other_action"></slot>
                <span v-if="can_change">
                <v-btn v-can="{obj_type:'instrument', action: 'edit'}" color="primary" @click.stop="editInstrument" fab small><v-icon class="pa-2" small>create</v-icon></v-btn>
                <v-btn v-can="{obj_type:'instrument', action: 'edit'}" color="primary" @click.stop="cloneInstrument" fab small><v-icon class="pa-2" small>file_copy</v-icon></v-btn>
                <v-btn v-can="{obj_type:'instrument', action: 'remove'}" color="primary" @click.stop="openDeleteInstrumentConfirm" fab small><v-icon class="pa-2" small>delete</v-icon></v-btn>
                </span>
            </v-col>
            <v-col cols="12" sm="12" md="9" class="d-flex align-start justify-start order-xs-2 order-sm-2 order-md-1 pb-1 cursor_pointer" @click.stop.prevent="itemDetails">
                <div width="100%" class="d-flex flex-grow-1 flex-shrink-0 align-start justify-center fill-height">
                    <div class="d-flex flex-shrink-1 flex-grow-0 pr-1">
                      <StatusIcon :status="iconStatus.instrument" :tooltip_text="instr_tooltip[iconStatus.instrument]" />
                    </div>
                    <div class="d-flex flex-column flex-grow-1 flex-shrink-0">
                        <div class="d-flex flex-row">
                            <span class="font-italic d-flex flex-grow-1 flex-shrink-0">
                                <b v-if="instrument.name!=''">{{ instrument.name }} / </b><b>{{ instrument.serno }}</b> - <b>{{ instrument.manufacturer}}</b> - <b>{{ instrument.model }}</b> </span>
                            <i class="d-flex flex-grow-0 flex-shrink-1">
                                {{ instrument.family }}<br/>
                            </i>
                        </div>
                        <div class="d-flex flex-grow-1 flex-shrink-0">
                            <div class="d-flex flex-column flex-grow-1 flex-shrink-0">
                                <div v-if="!!client"><b>{{ client.name }}</b> - PIVA: {{ client.piva }}</div>
                                <div v-if="!!location">
                                    {{ location.name }} - {{ location.address}} {{ location.addrNum }}, {{ location.city }} ({{ location.district }})<br/>
                                    <span v-if="instrument.department_id  && location.departments[instrument.department_id]">{{ location.departments[instrument.department_id].name }}</span>
                                </div>
                                <div class="font-italic" v-if="report_count.length == 1 && report_count[0].value > 0">Nr. report effettuati: {{ report_count[0].value }}</div>
                                <div v-for="(report,idx) of Object.keys(iconStatus)" :key="idx+'_'+instrument.updated">
                                    <div v-if="report!='instrument' && instrument.metrological_info[report] && instrument.metrological_info[report].next_operation">
                                        <StatusIcon class="pr-2" small :status="iconStatus[report]" :tooltip_text="report_tooltip[iconStatus[report]]" />{{report}}: {{ instrument.metrological_info[report].next_operation | formatDateTS }}
                                    </div>
                                </div>
                                <div class="caption font-italic">
                                    aggiornato il {{ instrument.updated | formatDateTS }}
                                </div>
                            </div>
                            <div class="d-flex flex-column flex-grow-0 flex-shrink-1" v-if="show_platform_capacity">
                                <div v-for="platform in instrument.platforms" :key="platform.id">
                                <InstrumentPlatformInfo class="text-right ml-2"
                                    v-bind:o_data="platform"/>
                                </div>
                            </div>
                            
                        </div>
                        <!--InstrumentItemInfo
                            v-else
                            :instrument="instrument"
                            :client="client"
                            :location="location"
                            :show_platform_capacity="show_platform_capacity">
                            <slot name="other_info"></slot>
                            <template v-slot:other_info>
                                <div v-for="(report,idx) of Object.keys(iconStatus)" :key="idx+'_'+instrument.updated">
                                <div v-if="report!='instrument' && instrument.metrological_info[report] && instrument.metrological_info[report].next_operation">
                                    <StatusIcon class="pr-2" small :status="iconStatus[report]" />{{report}}: {{ instrument.metrological_info[report].next_operation | formatDateTS }}
                                </div>
                                </div>            
                            </template>
                        </InstrumentItemInfo-->
                    </div>
                </div>
            </v-col>
        </v-row>
        <ConfirmDialog
            v-bind:data="delete_confirm"
            v-on:close_dialog="closeDialog"
            v-on:confirm_result="onDeleteConfirm"/>
        <InstrumentDialog
            ref="instrumentEdit"
            v-on:update_instrument="updateInstrument"
        />
    </v-container>
</template>
<script>
// import _ from 'lodash'

import ConfirmDialog from '../../components/dialogs/ConfirmDialog'
import StatusIcon from '../../components/utils/StatusIcon'
import InstrumentDialog from "./InstrumentDialog"
import InstrumentPlatformInfo from './Instrument_utils/Instrument_platform_info'
import {searchDesign} from "../../utils/dbUtility"
import { getObjStatus } from '../../utils/commonUtils'
import { i_families, instrument_status_tooltip, report_status_tooltip } from "../../utils/common.js"
 

export default {
    components: {ConfirmDialog, InstrumentDialog, InstrumentPlatformInfo, StatusIcon},
    props: {
        instrument_id: {
            type: String,
            required: true
        },
        show_client: {
            type: Boolean,
            required: false,
            default: true
        },
        show_location: {
            type: Boolean,
            required: false,
            default: true
        },
        enable_clone: {
            type: Boolean,
            required: false,
            default: true
        },
        can_change: {
            type: Boolean,
            required: false,
            default: true
        },
        show_platform_capacity: {
            type: Boolean,
            required: false,
            default: false
        },
        disable_link: {
            type: Boolean,
            required: false,
            default: false
        },
        lock_client: {
            type: Boolean,
            required: false,
            default: false
        },
        deletable: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data(){
        return {
            delete_confirm: {
                dialog: false,
                title: 'Archivia strumento',
                message: "Sei sicuro di voler archiviare lo strumento selezionato?",
                choices: [
                    {key: "cancel", val: "annulla", mod: "success"},
                    {key: "delete", val: "elimina"}
                    ]
            },
            loading: true,
            instrument: null,
            client: null,
            location: null,
            report_count: null,
            iconStatus: {},
            instr_tooltip: instrument_status_tooltip,
            report_tooltip: report_status_tooltip
        }
    },
    computed: {
        
    },
    async mounted() {
        await this.loadInstrument()
    },
    methods: {
        openDeleteInstrumentConfirm(){
            console.log('DELETE')
            this.delete_confirm.message = "Sei sicuro di voler archiviare <br/><b>" + this.instrument.name+" / "+ this.instrument.serno+" - "+this.instrument.manufacturer+" - "+this.instrument.model+"</b>?"
            this.delete_confirm.dialog = true;
        },
        async onDeleteConfirm(choice){
            try {
                if(choice == "delete"){
                    this.instrument.updated_by = this.$store.state.user._id
                    this.instrument.updated = (new Date()).getTime()
                    this.instrument.dismissed = true
                    let res = await this.$store.state.$pouch.put('registry', this.instrument)
                    if (res.ok) {
                        this.instrument._rev = res.rev
                        this.$emit('instrument_removed', this.instrument._id)
                    }
                } 
                this.closeDialog()
            } catch(error) {
                console.log('error', error)
            }
        },
        closeDialog(){
            this.delete_confirm.dialog = false;
        },

        itemDetails(){
            if (this.disable_link) return
            // console.log('§§§§§§§§§§§§§§ ITEM', this.lock_client)
            this.$router.push({path: "/instruments/details", query: {i_id: this.instrument_id, lock_client: this.lock_client, back: this.$router.history.current.fullPath}})
        },
        editInstrument(){
            //this.$router.push({path: '/instrument/edit'})
            
            this.$refs.instrumentEdit.openDialog({instrument_id: this.instrument_id, 
                lock_client: this.lock_client, 
                primary: this.instrument.primary,
                org_id: this.instrument.org_id});
        },
        cloneInstrument(){
            this.$refs.instrumentEdit.openDialog({instrument_id: this.instrument_id, lock_client: this.lock_client, clone: true, 
                primary: this.instrument.primary,
                org_id: this.instrument.org_id});
        },
        updateInstrument(instr_id) {
            if (instr_id == this.instrument_id) {
                // UPDATE INSTRUMENT
                this.$emit('update_instrument', instr_id)
                this.loadInstrument()
            } else {
                // CLONE INSTRUMENT
                this.$emit('add_instrument', instr_id)
            }
        },
        async loadInstrument() {
            this.loading = true
            // console.log('LOAD INSTRUMENT')
            this.instrument = await this.$store.state.$pouch.get('registry', this.instrument_id)
        
            if (this.show_client) {
                this.client = await this.$store.state.$pouch.get('registry', this.instrument.client_id)
            }
            if (this.show_location) {
                this.location = await this.$store.state.$pouch.get('registry', this.instrument.location_id)
            }

            this.report_count = await searchDesign(this.$store.state.$pouch, 'reports', 'reports/searchByData', 'key', this.instrument_id, true)
            
            this.getStatusIcon()
            this.loading = false
        },
        getStatusIcon() {
            let data = {expire_status: true}
            data.allowed_report = Object.keys(i_families[this.instrument.family].report)
            this.iconStatus = getObjStatus(this.$store.state.config.threshold, this.instrument, data)
            //console.log("**** STATUS", this.iconStatus)
        },
    },
    
    
}

</script>